import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { typeScale, lineHeight } from 'styles/globals';
import { getDarkerColorShadeHex, remToPx } from '../../ui';

// SDK3 sets a line height on the body variants; SDK2 doesn't support it.
export function buildMindsetTextStyles() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$includeBodyLineH = _ref.includeBodyLineHeight,
    includeBodyLineHeight = _ref$includeBodyLineH === void 0 ? false : _ref$includeBodyLineH;
  var bodyHeight = includeBodyLineHeight ? {
    height: lineHeight
  } : {};
  return {
    titleLarge: {
      fontWeight: 600,
      fontSize: remToPx(typeScale.l)
    },
    titleMedium: {
      fontWeight: 600,
      fontSize: remToPx(typeScale.m)
    },
    titleSmall: {
      fontWeight: 600,
      fontSize: remToPx(typeScale.m)
    },
    bodyLarge: _objectSpread({
      fontWeight: 400,
      fontSize: remToPx(typeScale.m)
    }, bodyHeight),
    bodyMedium: _objectSpread({
      fontWeight: 400,
      fontSize: remToPx(typeScale.s)
    }, bodyHeight),
    bodySmall: _objectSpread({
      fontWeight: 400,
      fontSize: remToPx(typeScale.s)
    }, bodyHeight)
  };
}
export function buildMindsetTheme(theme) {
  var cardTheme = theme.sections.card;
  var errorColor = theme.globals.colorBlocks.negative;
  var primaryButtonColor = theme.globals.buttons.primary;
  var defaultButtonColor = theme.globals.buttons.default;
  var importantButtonColor = theme.globals.buttons.important;
  var mindsetPrimaryText = theme.globals.colorBlocks.mindset;
  var mindsetPrimaryRawBg = theme.globals.colorBlocks['mindset-background'];
  var mindsetPrimaryBg = mindsetPrimaryRawBg === cardTheme.background ? getDarkerColorShadeHex(mindsetPrimaryRawBg) : mindsetPrimaryRawBg;
  var cardBgDarker = getDarkerColorShadeHex(cardTheme.background);
  return {
    brightness: 'light',
    surfaceTint: null,
    primary: mindsetPrimaryText,
    onPrimary: mindsetPrimaryBg,
    primaryContainer: mindsetPrimaryBg,
    onPrimaryContainer: mindsetPrimaryText,
    secondary: defaultButtonColor.text,
    onSecondary: defaultButtonColor.background,
    secondaryContainer: defaultButtonColor.text,
    onSecondaryContainer: defaultButtonColor.background,
    tertiary: importantButtonColor.text,
    onTertiary: importantButtonColor.background,
    tertiaryContainer: importantButtonColor.text,
    onTertiaryContainer: importantButtonColor.background,
    error: errorColor,
    onError: cardTheme.text,
    errorContainer: cardTheme.text,
    onErrorContainer: errorColor,
    background: cardTheme.background,
    onBackground: cardTheme.text,
    surface: cardTheme.background,
    onSurface: cardTheme.text,
    surfaceVariant: cardTheme.background,
    onSurfaceVariant: cardTheme.text,
    outline: cardTheme.text,
    outlineVariant: cardTheme.text,
    shadow: cardTheme.shade,
    scrim: '#000000',
    inverseSurface: cardTheme.text,
    inverseOnSurface: cardTheme.background,
    inversePrimary: primaryButtonColor.text,
    primaryFixed: primaryButtonColor.background,
    onPrimaryFixed: primaryButtonColor.text,
    primaryFixedDim: getDarkerColorShadeHex(primaryButtonColor.background),
    onPrimaryFixedVariant: primaryButtonColor.text,
    secondaryFixed: defaultButtonColor.background,
    onSecondaryFixed: defaultButtonColor.text,
    secondaryFixedDim: getDarkerColorShadeHex(defaultButtonColor.background),
    onSecondaryFixedVariant: defaultButtonColor.text,
    tertiaryFixed: importantButtonColor.background,
    onTertiaryFixed: importantButtonColor.text,
    tertiaryFixedDim: getDarkerColorShadeHex(importantButtonColor.background),
    onTertiaryFixedVariant: importantButtonColor.text,
    surfaceDim: cardBgDarker,
    surfaceBright: getDarkerColorShadeHex(cardTheme.background, 0.01),
    surfaceContainerLowest: cardBgDarker,
    surfaceContainerLow: cardBgDarker,
    surfaceContainer: cardBgDarker,
    surfaceContainerHigh: cardBgDarker,
    surfaceContainerHighest: cardBgDarker
  };
}